export default __webpack_public_path__ + "static/hotel-utter-inn-dc5043204a5c3df875438015caa3c206.jpg";